<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    class="w-6 h-6 fill-current"
  >
    <path
      d="M7 1C3.742 1 1 3.184 1 6c0 .965.36 1.848.914 2.602l-.34 2.644 2.418-1c.656.32 1.367.57 2.133.684.465 1.793 2.27 3.097 4.375 3.097.887 0 1.66-.32 2.36-.714l1.703 1.003L14.305 12c.386-.59.695-1.238.695-1.973 0-1.422-.828-2.644-2.059-3.355C12.977 6.453 13 6.23 13 6c0-2.816-2.742-5-6-5Zm0 1c2.816 0 5 1.844 5 4 0 .09-.016.18-.023.266a4.973 4.973 0 0 0-1.477-.239c-2.402 0-4.414 1.7-4.484 3.883a5.762 5.762 0 0 1-1.844-.613L3.96 9.18l-1.172.484.168-1.305-.137-.168C2.297 7.551 2 6.805 2 6c0-2.156 2.184-4 5-4ZM5.5 4c-.277 0-.5.223-.5.5s.223.5.5.5.5-.223.5-.5-.223-.5-.5-.5Zm3 0c-.277 0-.5.223-.5.5s.223.5.5.5.5-.223.5-.5-.223-.5-.5-.5Zm2 3.027c1.973 0 3.5 1.375 3.5 3 0 .618-.215 1.184-.594 1.664l-.125.164.024.204.043.379-.41-.243-.266.18a3.876 3.876 0 0 1-2.172.652c-1.918 0-3.402-1.3-3.484-2.867V10h-.012C7.02 8.387 8.539 7.027 10.5 7.027ZM9.5 9c-.277 0-.5.223-.5.5s.223.5.5.5.5-.223.5-.5-.223-.5-.5-.5Zm2 0c-.277 0-.5.223-.5.5s.223.5.5.5.5-.223.5-.5-.223-.5-.5-.5Z"
    />
  </svg>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
</style>